const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const ARGENTINE_DATE_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

const mendozaDateFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Argentina/Mendoza",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

function validCalendarDate(year, month, day) {
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}

function joinedDate(year, month, day) {
  const numericYear = Number(year);
  const numericMonth = Number(month);
  const numericDay = Number(day);
  if (!validCalendarDate(numericYear, numericMonth, numericDay)) return "";
  return [
    String(numericDay).padStart(2, "0"),
    String(numericMonth).padStart(2, "0"),
    String(numericYear).padStart(4, "0"),
  ].join("/");
}

export function formatDateForCopy(value) {
  if (value === null || value === undefined || value === "") return "";

  if (typeof value === "string") {
    const normalized = value.trim();
    const dateOnlyMatch = DATE_ONLY_PATTERN.exec(normalized);
    if (dateOnlyMatch) {
      return joinedDate(dateOnlyMatch[1], dateOnlyMatch[2], dateOnlyMatch[3]);
    }
    const argentineMatch = ARGENTINE_DATE_PATTERN.exec(normalized);
    if (argentineMatch) {
      return joinedDate(
        argentineMatch[3],
        argentineMatch[2],
        argentineMatch[1],
      );
    }
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const parts = Object.fromEntries(
    mendozaDateFormatter
      .formatToParts(date)
      .filter(({ type }) => type !== "literal")
      .map(({ type, value: partValue }) => [type, partValue]),
  );
  return joinedDate(parts.year, parts.month, parts.day);
}
